import { defineComponent, computed } from '@vue/composition-api';
import { getBaseFileName } from './url/resolveImageSource.js';

var defaultExtension = 'png';
var validExtensions = [
    'png',
    'jpg',
    'jpeg',
    'webp',
];
var script = defineComponent({
    name: 'CustomImage',
    props: {
        src: {
            type: String,
            required: true,
        },
        alt: {
            type: String,
            required: false,
            default: '', // Means presentational for alt
        },
        isRetina: {
            type: Boolean,
            required: false,
            default: false,
        },
        suffix: {
            type: String,
            required: false,
            default: '_2x',
        },
    },
    setup: function (props) {
        var fileName = computed(function () { return getBaseFileName(props.src); });
        var legacyExtension = computed(function () {
            var parts = props.src.split('.');
            if (parts.length > 1) {
                var extension = parts.pop();
                if (!validExtensions.includes(extension)) {
                    return defaultExtension;
                }
                return extension;
            }
            return defaultExtension;
        });
        var webPSrc = computed(function () {
            return props.isRetina ? "".concat(fileName.value, ".webp 1x, ").concat(fileName.value).concat(props.suffix, ".webp 2x") : "".concat(fileName.value, ".webp");
        });
        var legacySrc = computed(function () {
            return props.isRetina ? "".concat(fileName.value, ".").concat(legacyExtension.value, " 1x, ").concat(fileName.value).concat(props.suffix, ".").concat(legacyExtension.value, " 2x") : "".concat(fileName.value, ".").concat(legacyExtension.value);
        });
        var legacyImgSrc = computed(function () {
            return "".concat(fileName.value, ".").concat(legacyExtension.value);
        });
        var legacyType = computed(function () {
            switch (legacyExtension.value) {
                case 'png':
                    return 'image/png';
                case 'webp':
                    return 'image/webp';
                default:
                    return 'image/jpeg';
            }
        });
        return {
            fileName: fileName,
            webPSrc: webPSrc,
            legacySrc: legacySrc,
            legacyType: legacyType,
            legacyImgSrc: legacyImgSrc,
            legacyExtension: legacyExtension,
        };
    },
});

export default script;
